'use client'

import { urlUtils } from '@/app/lib/utils'
import { useSearchParams } from 'next/navigation'
import React, { Suspense } from 'react'
import { Button } from '@/components/ui/button'

interface ErrorBoundaryProps {
  children: React.ReactNode
}

function ErrorBoundaryContent({ children }: ErrorBoundaryProps) {
  const searchParams = useSearchParams()
  const paramString = searchParams || ''
  const decodedParams = paramString ? urlUtils.decode(paramString) : {}

  const error = decodedParams?.error
  const message = decodedParams.message

  return (
    <div className="relative w-full">
      <div
        className={`grid gap-5 overflow-hidden 2xl:grid-rows-[5em_1fr] xl:overflow-visible 2xl:h-full ${error ? 'blur-[2px]' : ''}xl:gap-6`}
      >
        {children}
      </div>

      {error && (
        <div className="fixed inset-0 flex items-center justify-center z-50 xl:w-1/2 m-auto">
          <div className="grid gap-4 bg-red-100 border border-red-600 text-red-600 m-5 px-4 py-3 rounded-md shadow-xl w-full">
            <p className="font-bold">Une erreur est survenue: </p>
            <p>{message}</p>
            <Button
              size="lg"
              variant="destructive"
              className="xl:w-1/4 m-auto"
              onClick={() => (window.location.href = window.location.pathname)}
            >
              Fermer
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export function ErrorBoundary(props: ErrorBoundaryProps) {
  return (
    <Suspense fallback={<div>Chargement...</div>}>
      <ErrorBoundaryContent {...props} />
    </Suspense>
  )
}
